<template>
  <div class="home">
    <div style="width: 100%">
      <div class="row">
        <button class="copy-link-btn zfbg-btn" @click="copyBaogao(0)">
          转发报告
        </button>
        <div class="top_down">
          <li class="copybox" @click="copyBaogao(1)">{{ jichu_info.title }}</li>
        </div>
      </div>
      <div style="height: 100%">
        <div class="middle_Basic_information">
          <ul class="middle_Basic_information_top">
            <div
              :class="[
                'middle_Basic_information_top_info',
                isSelect == 1 ? 'selected' : '',
              ]"
              @click="change(1)"
            >
              基本信息
            </div>
            <div
              :class="[
                'middle_Basic_information_top_info',
                isSelect == 2 ? 'selected' : '',
              ]"
              @click="change(2)"
            >
              纳税信息
            </div>
            <div
              :class="[
                'middle_Basic_information_top_info',
                isSelect == 3 ? 'selected' : '',
              ]"
              @click="change(3)"
            >
              发票信息
            </div>
            <div
              :class="[
                'middle_Basic_information_top_info',
                isSelect == 4 ? 'selected' : '',
              ]"
              @click="change(4)"
            >
              供应商信息
            </div>
          </ul>
          <!-- 基本信息 -->
          <div class="middle_all" v-if="isSelect == 1">
            <ul
              class="middle_Basic_information_middle"
              style="margin-bottom: 10px"
            >
              <li>
                <span class="middle_Basic_information_middle_left"
                  >报告创建时间</span
                >
                <span class="middle_Basic_information_middle_right">
                  <p>{{ jichu_info.cjsj }}</p>
                </span>
              </li>
              <li>
                <span class="middle_Basic_information_middle_left"
                  >企业名称</span
                >
                <span class="middle_Basic_information_middle_right">
                  <p @click="copyBaogao(1)">
                    {{ jichu_info.title }}<em style="color: blue">复制</em>
                  </p>
                </span>
              </li>
              <li>
                <span class="middle_Basic_information_middle_left"
                  >当前法人姓名</span
                >
                <span class="middle_Basic_information_middle_right">
                  <p @click="copyBaogao(3)">
                    {{ jichu_info.frxm }}<em style="color: blue">复制</em>
                  </p>
                </span>
              </li>
              <li>
                <span class="middle_Basic_information_middle_left"
                  >法人占股比例</span
                >
                <span class="middle_Basic_information_middle_right">
                  <p>{{ jichu_info.frzgbl }}</p>
                </span>
              </li>
              <li>
                <span class="middle_Basic_information_middle_left"
                  >成立日期</span
                >
                <span class="middle_Basic_information_middle_right">
                  <p>{{ jichu_info.found_date }}</p>
                </span>
              </li>
              <li>
                <span class="middle_Basic_information_middle_left"
                  >统一信用代码</span
                >
                <span class="middle_Basic_information_middle_right">
                  <p @click="copyBaogao(2)">
                    {{ jichu_info.xydm }}
                    <em style="color: blue">复制 </em>
                  </p>
                </span>
              </li>
              <li>
                <span class="middle_Basic_information_middle_left"
                  >行业分类</span
                >
                <span class="middle_Basic_information_middle_right">
                  <p>{{ jichu_info.hyfl }}</p>
                </span>
              </li>
              <li>
                <span class="middle_Basic_information_middle_left"
                  >注册资金</span
                >
                <span class="middle_Basic_information_middle_right">
                  <p>{{ formatRegCap(jichu_info.zczj) }}</p>
                </span>
              </li>
              <li>
                <span class="middle_Basic_information_middle_left"
                  >注册类型</span
                >
                <span class="middle_Basic_information_middle_right">
                  <p>{{ jichu_info.zclx }}</p>
                </span>
              </li>
              <li class="address-row">
                <span class="middle_Basic_information_middle_left"
                  >注册区域</span
                >
                <span class="middle_Basic_information_middle_right">
                  <p style="margin-right: -1rem">{{ jichu_info.zcqy }}</p>
                </span>
              </li>
              <div v-if="jichu_info.jy_score">
                <li>
                  <span
                    class="middle_Basic_information_middle_left"
                    style="color: rgb(98, 101, 113); font-size: 1.4rem"
                  >
                    水母经营分
                    <i
                      class="el-icon-question"
                      style="
                        margin-left: 6px;
                        cursor: pointer;
                        color: #409eff;
                        font-size: 1.5rem;
                      "
                      @click="toggleScoreTip"
                    ></i>
                  </span>
                  <span
                    class="middle_Basic_information_middle_right"
                    style="color: rgb(98, 101, 113); font-size: 1.4rem"
                  >
                    <p>{{ jichu_info.jy_score }}</p>
                  </span>
                </li>
                <div class="credit-score-wrap" style="padding-top: 0">
                  <div class="progress-container">
                    <div class="progress-bar">
                      <div class="progress-gradient"></div>
                      <div
                        class="score-pointer"
                        :style="scorePointerStyle"
                      ></div>
                    </div>
                    <div class="scale-texts">
                      <span style="left: 20%">20</span>
                      <span style="left: 40%">40</span>
                      <span style="left: 60%">60</span>
                      <span style="left: 80%">80</span>
                    </div>
                    <div class="labels">
                      <span style="left: 20%">经营一般</span>
                      <span style="left: 50%">经营良好</span>
                      <span style="left: 80%">经营卓越</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tip" v-if="jichu_info.jy_score && showScoreTip">
                水母经营分是基于报告信息运用AI模型计算得出的分值，会随报告内容更新而相应变化，分值仅供参考，用于辅助评估企业的总合经营状况，并不代表水母报告任何明示，暗示之观点或保证。
                <button class="view-detail-button" @click="smScoureShow = true">
                  查看具体说明
                </button>
              </div>
            </ul>
            <li class="new_li" v-if="hasSocialData">
              <br />
              <span
                class="middle_Basic_information_middle_left"
                style="font-weight: bold; width: 100%"
                >最近一次社保缴费记录</span
              >
            </li>
            <div class="tbdiv" v-if="hasSocialData">
              <table class="middle_Basic_information_tb" style="width: 95%">
                <thead>
                  <tr>
                    <th style="width: 30%">社保人数</th>
                    <th style="width: 30%">应缴费额(元)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ jichu_info.sbrs }}</td>
                    <td>{{ jichu_info.sbjf }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="tip" v-if="hasSocialData">
              社保人数和应缴费额的值取的是职工基本养老保险(单位缴纳人数及金额)
            </div>

            <li class="new_li" v-if="gudong_list_all.length > 0">
              <br />
              <span
                class="middle_Basic_information_middle_left"
                style="font-weight: bold"
                >股东明细</span
              >
            </li>
            <div class="tbdiv" v-if="gudong_list_all.length > 0">
              <table class="middle_Basic_information_tb" style="width: 95%">
                <thead>
                  <tr>
                    <th style="width: 45%">股东名称</th>
                    <th style="width: 45%">参股比例</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in gudong_list"
                    :key="index"
                    :class="index % 2 == 1 ? 'odd' : ''"
                  >
                    <td>{{ item.name }}</td>
                    <td>{{ item.cgbl }}</td>
                  </tr>
                  <tr
                    class="additional-row"
                    @click="gdmx_zksq_change()"
                    v-if="gudong_list_all.length > 3"
                  >
                    <td colspan="2">
                      <p style="color: blue">{{ gdmx_zksq }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <li class="new_li">
              <br />
              <br />
              <span
                class="middle_Basic_information_middle_left"
                style="font-weight: bold; display: flex; width: 100%"
              >
                银税互动授权记录:
                {{ yshd_list_all.length == 0 ? "无" : "" }}
              </span>
            </li>
            <div class="tbdiv" v-if="yshd_list_all.length > 0">
              <table class="middle_Basic_information_tb" style="width: 95%">
                <thead>
                  <tr>
                    <th style="width: 30%">银行名称</th>
                    <th style="width: 30%">申请时间</th>
                    <th style="width: 30%">状态</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in yshd_list"
                    :key="'yshd-' + index"
                    :class="index % 2 == 1 ? 'odd' : ''"
                  >
                    <td>{{ item.yhmc }}</td>
                    <td>{{ item.sqsj }}</td>
                    <td>{{ item.zt || "-" }}</td>
                  </tr>
                  <tr
                    class="additional-row"
                    @click="yshd_zksq_change()"
                    v-if="yshd_list_all.length > 3"
                  >
                    <td colspan="3">
                      <p style="color: blue">{{ yshd_zksq }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="bottom_img">
              <img src="../assets/gzg.jpg" alt="" />
            </div>
          </div>

          <!-- 纳税信息 -->
          <div class="middle_all" v-if="isSelect == 2">
            <div class="middle_Basic_information_middle_second">
              <li>
                <p>纳税信用等级</p>
                <span>{{ ns_info.xydj }}</span>
              </li>
              <li>
                <p>近12月增税销售额（元）</p>
                <span>{{ ns_info.zzxse_12 }}</span>
              </li>
              <li>
                <p>纳税人种类</p>
                <span>{{ ns_info.nsrzl }}</span>
              </li>
              <li>
                <p>近24月增税销售额（元）</p>
                <span>{{ ns_info.zzxse_24 }}</span>
              </li>
              <li>
                <p>近12月欠税记录次数</p>
                <span>{{ ns_info.qsjlcs_12 }}</span>
              </li>
              <li>
                <p>近12月完税总额(元)</p>
                <span>{{ ns_info.nsze_12 }}</span>
              </li>
              <li>
                <p>当前欠税余额（元）</p>
                <span>{{ ns_info.dqqcje }}</span>
              </li>
              <li>
                <p>近24月完税总额(元)</p>
                <span>{{ ns_info.nsze_24 }}</span>
              </li>
              <li>
                <p>近3个月滞纳金金额(元)</p>
                <span>{{ ns_info.yznjje_3 }}</span>
              </li>
              <li>
                <p>近12月增税应纳额(元)</p>
                <span>{{ ns_info.zsyne_12 }}</span>
              </li>
              <li>
                <p>近12个月滞纳金金额(元)</p>
                <span>{{ ns_info.znjje_12 }}</span>
              </li>
              <li>
                <p>近12月0申报月数(月)</p>
                <span>{{ ns_info.sbys_120 }}</span>
              </li>
              <li>
                <p>近12月滞纳金次数</p>
                <span>{{ ns_info.znjcs_12 }}</span>
              </li>
              <li>
                <p>近12月最长连续0纳税申报月数</p>
                <span>{{ ns_info.zclx0sbys_12 }}</span>
              </li>
              <div class="yishang">
                <span>以上数据不含本月</span>
              </div>

              <li style="width: 100%">
                <br />
                <span
                  class="middle_Basic_information_middle_left"
                  style="
                    width: 100%;
                    font-size: 1.4rem;
                    color: rgb(98, 101, 113);
                    font-weight: bold;
                  "
                >
                  财报信息
                </span>
              </li>
              <li>
                <p>资产金额（去年年报）</p>
                <span>{{ ns_info.qnzcje }}</span>
              </li>
              <li>
                <p>负债率（去年年报）</p>
                <span>{{ ns_info.qnfzl }}</span>
              </li>
              <li>
                <p>营业利润额（去年年报）</p>
                <span>{{ ns_info.qnlre }}</span>
              </li>
              <li>
                <p>营业净利率（去年年报）</p>
                <span>{{ ns_info.qzjll }}</span>
              </li>
            </div>

            <div
              style="border-bottom: 1px dashed gray; margin: 10px 0; width: 90%"
            ></div>

            <li class="new_li" style="width: 100%">
              <br />
              <span
                class="middle_Basic_information_middle_left"
                style="
                  width: 100%;
                  font-size: 1.3rem;
                  color: rgb(98, 101, 113);
                  font-weight: bold;
                "
                >滞纳金情况: {{ znj_list_all.length == 0 ? "无" : "" }}</span
              >
            </li>
            <div class="tbdiv" v-if="!znj_list_all.length == 0">
              <table class="middle_Basic_information_tb" style="width: 95%">
                <thead>
                  <tr>
                    <th style="width: 30%">滞纳金时间</th>
                    <th style="width: 30%">滞纳金金额(元)</th>
                    <th style="width: 30%">状态</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in znj_list"
                    :key="index"
                    :class="index % 2 == 1 ? 'odd' : ''"
                  >
                    <td>{{ item.znsj }}</td>
                    <td>{{ item.zhje }}</td>
                    <td>{{ item.zt || "已缴清" }}</td>
                  </tr>

                  <tr
                    class="additional-row"
                    @click="znj_zksq_change()"
                    v-if="znj_list_all.length > 2"
                  >
                    <td colspan="3">
                      <p style="color: blue">{{ znj_zksq }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="tip" v-if="!znj_list_all.length == 0">
              税务逾期和滞纳金是企业注册地区税局记录生成的（如有记录，可自行登录当地电子税务局看到），我方无法修改，报告内容仅供参考，不能用于任何用途。
              <button class="view-detail-button" @click="znjModalchange()">
                查看详细路径
              </button>
            </div>

            <li class="new_li" style="width: 100%">
              <br />
              <span
                class="middle_Basic_information_middle_left"
                style="
                  width: 100%;
                  font-size: 1.3rem;
                  color: rgb(98, 101, 113);
                  font-weight: bold;
                "
                >税务处罚: {{ swcf_list.length == 0 ? "无" : "" }}</span
              >
            </li>
            <div class="tbdiv" v-if="!swcf_list.length == 0">
              <table class="middle_Basic_information_tb" style="width: 95%">
                <thead>
                  <tr>
                    <th style="width: 23%">登记日期</th>
                    <th style="width: 33%">违法违章信息</th>
                    <th style="width: 23%">状态</th>
                    <th style="width: 23%">详细信息</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in swcf_list1"
                    :key="index"
                    :class="index % 2 == 1 ? 'odd' : ''"
                  >
                    <td>{{ item.djrq }}</td>
                    <td>{{ item.wfwzxx }}</td>
                    <td>{{ item.wfwzzt }}</td>
                    <td style="color: blue" @click="lookSwcf(item)">查看</td>
                  </tr>
                  <tr
                    class="additional-row"
                    @click="zksq()"
                    v-if="swcf_list.length > 2"
                  >
                    <td colspan="4">
                      <p style="color: blue">{{ swcf_zksq }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tip" v-if="!swcf_list.length == 0">
              税务逾期记录可自行前往电子税务局-税务数字账户-账户查询-违法违章信息查询中将状态选为全部，即可查到对应记录。
              <button class="view-detail-button" @click="swcfModalChange()">
                查看详细路径
              </button>
            </div>

            <div>
              <p
                style="
                  font-size: 1.5rem;
                  margin-left: 2rem;
                  margin-top: 2rem;
                  margin-bottom: 2rem;
                "
              >
                近三年纳税信息完税表(元)
              </p>
              <div class="middle_all_divtb3">
                <table class="middle_all_3_tb">
                  <thead>
                    <tr class="odd">
                      <th style="width: 15rem">月份</th>
                      <th style="width: 15rem">2024</th>
                      <th style="width: 15rem">2025</th>
                      <th style="width: 15rem">2026</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in wsb_list.slice(0, 12)"
                      :key="index"
                      :class="index % 2 == 1 ? 'odd' : ''"
                    >
                      <td>{{ item.yf }}</td>
                      <td>{{ item.y2023 }}</td>
                      <td>{{ item.y2024 }}</td>
                      <td>{{ item.y2025 }}</td>
                    </tr>
                    <tr style="background-color: rgb(179, 219, 245)">
                      <td style="font-weight: bolder">{{ wsb_list[12].yf }}</td>
                      <td>{{ wsb_list[12].y2023 }}</td>
                      <td>{{ wsb_list[12].y2024 }}</td>
                      <td>{{ wsb_list[12].y2025 }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="bottom_img">
              <img src="../assets/gzg.jpg" alt="" />
            </div>
          </div>

          <!-- 发票信息 -->
          <div class="middle_all" v-if="isSelect == 3">
            <div class="middle_Basic_information_middle_second">
              <li style="width: 100%">
                <br />
                <span
                  class="middle_Basic_information_middle_left"
                  style="
                    width: 100%;
                    font-size: 1.4rem;
                    color: rgb(98, 101, 113);
                    font-weight: bold;
                  "
                >
                  开票金额汇总（不含本月）
                </span>
              </li>
              <li>
                <p>近1个月开票金额(元)</p>
                <span>{{ fp_info.kpje_1 }}</span>
              </li>
              <li>
                <p>近12个月开票金额(元)</p>
                <span>{{ fp_info.kpje_12 }}</span>
              </li>
              <li>
                <p>近3个月开票金额(元)</p>
                <span>{{ fp_info.kpje_3 }}</span>
              </li>
              <li>
                <p>近24个月开票金额(元)</p>
                <span>{{ fp_info.kpje_24 }}</span>
              </li>
              <li>
                <p>近6月开票金额(元)</p>
                <span>{{ fp_info.kpje_6 }}</span>
              </li>
              <div
                style="
                  border-bottom: 1px dashed gray;
                  margin-bottom: 10px;
                  width: 90%;
                "
              ></div>
              <li style="width: 100%">
                <br />
                <span
                  class="middle_Basic_information_middle_left"
                  style="
                    width: 100%;
                    font-size: 1.4rem;
                    color: rgb(98, 101, 113);
                    font-weight: bold;
                  "
                >
                  开票金额环比增长率（不含本月）
                </span>
              </li>

              <li>
                <p>近3月开票环比增长率</p>
                <span>{{ fp_info.kphb_3 }}</span>
              </li>
              <li>
                <p>近12月开票环比增长率</p>
                <span>{{ fp_info.kphb_12 }}</span>
              </li>
              <li>
                <p>近6开票环比增长率</p>
                <span>{{ fp_info.kphb_6 }}</span>
              </li>
              <div
                style="
                  border-bottom: 1px dashed gray;
                  margin-bottom: 10px;
                  width: 90%;
                "
              ></div>

              <li>
                <p>近45日是否有开票记录</p>
                <span>{{ fp_info.kpjj_45 }}</span>
              </li>
              <li>
                <p>近12个月断票月数(不含2月份)</p>
                <span>{{ fp_info.zcdpb2_12 }}</span>
              </li>

              <li>
                <p>近3个月下游客户统计</p>
                <span>{{ fp_info.xykh_3 }}</span>
              </li>
              <li>
                <p>近12月最长连续断票月数</p>
                <span>{{ fp_info.zcdp_12 }}</span>
              </li>
              <li>
                <p>近12月下游客户数量(家)</p>
                <span>{{ fp_info.xykh_12 }}</span>
              </li>
              <li>
                <p>近12个月红冲金额占比</p>
                <span>{{ fp_info.hcjezb_12 }}</span>
              </li>
              <li>
                <p>近12个月下游开票张数</p>
                <span>{{ fp_info.xykp_12 }}</span>
              </li>
              <li>
                <p>近12月红冲发票张数占比</p>
                <span>{{ fp_info.hcfpzb_12 }}</span>
              </li>
              <li>
                <p>近12个月作废发票数量占比</p>
                <span>{{ fp_info.xykhzb_12 }}</span>
              </li>

              <!-- <li>
                <p>近12月月均开票金额增长率</p>
                <span>{{ fp_info.jkpzz_12 }}</span>
              </li> -->
              <li style="width: 100%">
                <p>近12个月最大连续未开票间隔天数（销项）</p>
                <span>{{ fp_info.zcwkp_12 }}</span>
              </li>
            </div>
            <div class="yishang">
              <span>以上数据不含本月</span>
            </div>
            <div>
              <p
                style="
                  font-size: 1.5rem;
                  margin-left: 2rem;
                  margin-top: 2rem;
                  margin-bottom: 2rem;
                "
              >
                近三年开票信息报表（元）
              </p>
              <div class="middle_all_divtb3">
                <table class="middle_all_3_tb">
                  <thead>
                    <tr class="odd">
                      <th style="width: 15rem">月份</th>
                      <th style="width: 15rem">2024</th>
                      <th style="width: 15rem">2025</th>
                      <th style="width: 15rem">2026</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in receipt_list.slice(0, 12)"
                      :key="index"
                      :class="index % 2 == 1 ? 'odd' : ''"
                    >
                      <td>{{ item.yf }}</td>
                      <td>{{ item.y2023 }}</td>
                      <td>{{ item.y2024 }}</td>
                      <td>{{ item.y2025 }}</td>
                    </tr>
                    <tr style="background-color: rgb(179, 219, 245)">
                      <td style="font-weight: bolder">年度汇总</td>
                      <td>{{ receipt_list[12].y2023 }}</td>
                      <td>{{ receipt_list[12].y2024 }}</td>
                      <td>{{ receipt_list[12].y2025 }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="bottom_img">
              <img src="../assets/gzg.jpg" alt="" />
            </div>
          </div>

          <!-- 供应商信息 -->
          <div class="middle_all_four" v-if="isSelect == 4">
            <!-- 公司前十 -->
            <div class="fonsi">
              <svg
                class="bi bi-person-lines-fill"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="20"
                fill="currentColor"
                viewBox="0 0 16 16"
                color="white"
              >
                <path
                  d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
                />
              </svg>
            </div>
            <span class="middle_all_4_span"> 近一年前十供应商信息 </span>
            <div class="separator"></div>
            <div class="middle_all_divtb4" style="margin-top: 10px">
              <table class="middle_all_4_tb">
                <thead>
                  <tr class="odd">
                    <th style="width: 10%">排名</th>
                    <th style="width: 25%">供应商名称</th>
                    <th style="width: 20%">采购额(元)</th>
                    <th style="width: 15%">金额占比(%)</th>
                    <th style="width: 15%">是否关联方</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in supplier_list"
                    :key="index"
                    :class="index % 2 == 1 ? 'odd' : ''"
                  >
                    <td>{{ item.pm }}</td>
                    <td>{{ item.gysmc }}</td>
                    <td>{{ item.cge }}</td>
                    <td style="color: rgb(255, 185, 78)">{{ item.jezb }}</td>
                    <td>{{ item.sfglf }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <!-- 客户前十 -->
            <div class="fonsi">
              <svg
                class="bi bi-person-lines-fill"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="20"
                fill="currentColor"
                viewBox="0 0 16 16"
                color="white"
              >
                <path
                  d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
                />
              </svg>
            </div>
            <span class="middle_all_4_span"> 近一年前十销售客户信息 </span>
            <div class="separator"></div>
            <div class="middle_all_divtb4" style="margin-top: 10px">
              <table class="middle_all_4_tb">
                <thead>
                  <tr class="odd">
                    <th style="width: 10%">排名</th>
                    <th style="width: 25%">客户名称</th>
                    <th style="width: 20%">销售额(元)</th>
                    <th style="width: 15%">金额占比(%)</th>
                    <th style="width: 15%">是否关联方</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in client_list"
                    :key="index"
                    :class="index % 2 == 1 ? 'odd' : ''"
                  >
                    <td>{{ item.pm }}</td>
                    <td>{{ item.khmc }}</td>
                    <td>{{ item.xse || item.cge }}</td>
                    <td style="color: rgb(255, 185, 78)">{{ item.jezb }}</td>
                    <td>{{ item.sfglf }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="bottom_img">
              <img src="../assets/gzg.jpg" alt="" />
            </div>
          </div>
        </div>
        <!-- 税务处罚模态框 -->
        <div class="modal-overlay" v-if="isModal2">
          <div class="modal-content">
            <h3>详情信息</h3>
            <p>
              <strong>登记日期：</strong>
              {{ swcf_xiangxi.djrq }}
            </p>
            <p>
              <strong>违法违章信息:</strong>
              {{ swcf_xiangxi.wfwzxx }}
            </p>
            <p>
              <strong>违法违章状态名称:</strong>
              已完结
            </p>
            <p>
              <strong>限改状态:</strong>
              {{ swcf_xiangxi.wfwzzt }}
            </p>
            <p>
              <strong>主要违法事实：</strong>
              {{ swcf_xiangxi.xxxx }}
            </p>
            <button @click="changeModel2()">关闭</button>
          </div>
        </div>
        <!-- 滞纳金模态框 -->
        <div
          class="modal-overlay"
          style="width: 95%; height: 95%"
          v-if="znjModal"
        >
          <div class="modal-content">
            <iframe
              src="http://zsqwh.7baidu.cc/index.html"
              width="100%"
              height="500px"
              frameborder="0"
            ></iframe>
            <button @click="znjModalchange()">关闭</button>
          </div>
        </div>

        <!-- 税务处罚模态框 -->
        <div
          class="modal-overlay"
          style="width: 95%; height: 95%"
          v-if="swcfModal"
        >
          <div class="modal-content">
            <iframe
              src="https://wytqb.7baidu.cc/index.html"
              width="100%"
              height="500px"
              frameborder="0"
            ></iframe>
            <button @click="swcfModalChange()">关闭</button>
          </div>
        </div>
        <!-- 经营分说明 -->
        <div class="modal-overlay score-modal-overlay" v-if="smScoureShow">
          <div class="modal-content score-modal-content">
            <div class="score-modal-body">
              <p class="score-notice">
                温馨提示：本水母经营分仅基于水母报告的经营数据生成，不具备信用评估功能，仅作为企业经营状况的参考信息，不构成任何投资、合作等建议。
              </p>
              <ul class="score-list">
                <li class="score-item">
                  <span class="score-label">80 分及以上,经营表现出众：</span
                  >基于报告经营数据，企业经营状况表现出众，纳税与开票记录规范优质，经营表现亮眼，增长动能充沛。
                </li>
                <li class="score-item">
                  <span class="score-label">70-79 分,经营表现卓越：</span
                  >基于报告经营数据，企业经营状况卓越，业务运转高效顺畅，具备良好的增长潜力与发展势头。
                </li>
                <li class="score-item">
                  <span class="score-label">56-69 分,经营表现优秀：</span
                  >基于报告经营数据，企业核心经营指标均达标，整体运营状况平稳有序，为长期持续发展奠定了扎实基础。
                </li>
                <li class="score-item">
                  <span class="score-label">41-55 分,经营表现良好：</span
                  >基于报告经营数据，企业经营整体稳定，部分运营指标仍有提升空间，持续规范管理即可稳步向好。
                </li>
                <li class="score-item">
                  <span class="score-label">0-40 分,经营表现平稳：</span
                  >基于报告经营数据，当前经营处于基础阶段，可通过规范日常管理、稳定开票纳税等方式，逐步夯实经营基础、优化发展状态。
                </li>
              </ul>
            </div>
            <button @click="smScoureShow = false">关闭</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      requestId: "", // 请求参数
      isSelect: 1,
      znjModal: false, // 滞纳金模态框
      swcfModal: false, // 税务处罚模态框
      isModal2: false, // 是否展示税务处罚明细
      showScoreTip: false,
      smScoureShow: false,
      //基础信息
      jichu_info: {
        cjsj: "",
        title: "",
        frxm: "",
        frnl: "",
        frzgbl: "",
        found_date: "",
        xydm: "",
        hyfl: "",
        zczj: "",
        zclx: "",
        zcqy: "",
        mbdz: "", // 链接
        sbrs: "",
        sbjf: "",
        jy_score: "",
      },
      yshd_list_all: [],
      yshd_list: [],
      yshd_zksq: "查看更多",
      gudong_list_all: [], //股东信息全部
      gudong_list: [], //股东信息
      isGdchange: false,
      //纳税信息
      ns_info: {
        xydj: "",
        zzxse_12: "",
        nsrzl: "",
        zzxse_24: "",
        qsjlcs_12: "",
        nsze_12: "",
        dqqcje: "",
        nsze_24: "",
        yznjje_3: "",
        zsyne_12: "",
        znjje_12: "",
        sbys_120: "",
        znjcs_12: "",
        zclx0sbys_12: "",
        qnzcje: "",
        qnlre: "",
        qnfzl: "",
        qzjll: "",
      },
      znj_list_all: [], // 滞纳金列表全部
      znj_list: [], // 滞纳金列表
      swcf_list: [], // 税务处罚列表全部
      swcf_list1: [], // 税务处罚列表
      znj_zksq: "展开", // 滞纳金数据展开收起
      swcf_zksq: "展开",
      gdmx_zksq: "查看更多",
      wsb_list: [], // 近三年完税表
      swcf_xiangxi: {},
      //发票信息
      fp_info: {
        kpjj_45: "",
        kpje_1: "",
        kphb_3: "",
        kpje_3: "",
        kphb_6: "",
        kpje_6: "",
        kphb_12: "",
        kpje_12: "",
        xykh_3: "",
        kpje_24: "",
        xykh_12: "",
        xykp_12: "",
        xykhzb_12: "",
        jkpzz_12: "",
        hcfpzb_12: "",
        hcjezb_12: "",
        zcdp_12: "",
        zcdpb2_12: "",
        zcwkp_12: "",
      },
      receipt_list: [],
      //供应商信息
      client_list: [],
      supplier_list: [],
    };
  },
  computed: {
    hasSocialData() {
      return !!(this.jichu_info.sbrs || this.jichu_info.sbjf);
    },
    scorePointerStyle() {
      const score = Math.min(
        Math.max(parseFloat(this.jichu_info.jy_score) || 0, 0),
        100,
      );
      return { left: score + "%" };
    },
  },
  // created() {
  //   if (this.$route.fullPath.length < 10) {
  //     this.$router.push({ path: "/about" });
  //   }
  // },
  mounted() {
    console.log(this.$route.fullPath);
    let lianjie = this.$route.fullPath;
    let lianjie2 = lianjie.split("?id=")[1];
    this.requestId = lianjie2.split("&state=")[0];

    console.log(this.requestId);
    this.getDataAll();
  },
  methods: {
    change(e) {
      this.isSelect = e;
    },
    toggleScoreTip() {
      this.showScoreTip = !this.showScoreTip;
    },
    formatRegCap(val) {
      if (!val) return "--";
      const text = String(val).trim();
      if (!text) return "--";
      // 已带币种则原样展示
      if (text.includes("人民币") || text.includes("美元")) {
        return text;
      }
      // 已是「xx万」时直接补人民币
      if (text.includes("万")) {
        return text + "人民币";
      }
      const matched = text.match(/^([\d.]+)/);
      let amount = matched ? parseFloat(matched[0]) : NaN;
      if (isNaN(amount) || amount <= 0) {
        return text;
      }
      amount = Math.floor(amount);
      const formatted =
        amount >= 10000 ? amount / 10000 + "万" : amount.toString();
      return formatted + "人民币";
    },
    //滞纳金模态框切换
    znjModalchange() {
      this.znjModal = !this.znjModal;
    },
    // 税务处罚展开收起
    zksq() {
      if (this.swcf_zksq == "收起") {
        this.swcf_list1 = this.swcf_list.slice(0, 2);
        this.swcf_zksq = "展开";
      } else if (this.swcf_zksq == "展开") {
        this.swcf_zksq = "收起";
        this.swcf_list1 = this.swcf_list;
      }
    },
    // 股东明细展开收起
    gdmx_zksq_change() {
      if (this.gdmx_zksq == "收起列表") {
        this.gudong_list = this.gudong_list_all.slice(0, 3);
        this.gdmx_zksq = "查看更多";
      } else if (this.gdmx_zksq == "查看更多") {
        this.gdmx_zksq = "收起列表";
        this.gudong_list = this.gudong_list_all;
      }
    },
    filterFilledYshd(list) {
      if (!Array.isArray(list)) return [];
      return list.filter((item) => {
        if (!item || typeof item !== "object") return false;
        const yhmc = String(item.yhmc || "").trim();
        const sqsj = String(item.sqsj || "").trim();
        const zt = String(item.zt || "").trim();
        return !!(yhmc || sqsj || zt);
      });
    },
    yshd_zksq_change() {
      if (this.yshd_zksq == "收起列表") {
        this.yshd_list = this.yshd_list_all.slice(0, 3);
        this.yshd_zksq = "查看更多";
      } else {
        this.yshd_zksq = "收起列表";
        this.yshd_list = this.yshd_list_all;
      }
    },
    // 滞纳金数据展开收起
    znj_zksq_change() {
      if (this.znj_zksq == "收起") {
        this.znj_list = this.znj_list_all.slice(0, 2);
        this.znj_zksq = "展开";
      } else if (this.znj_zksq == "展开") {
        this.znj_zksq = "收起";
        this.znj_list = this.znj_list_all;
      }
    },
    //税务处罚模态框切换
    swcfModalChange() {
      this.swcfModal = !this.swcfModal;
    },
    // 请求数据
    getDataAll() {
      this.$http.get(`index/getData?id=${this.requestId}`).then((res) => {
        console.log(res.data);

        if (res.data.code == "0") {
          this.$router.push({ path: "/about" });
        } else {
          // 基本信息
          let result = res.data.data;
          this.jichu_info.cjsj = result.jiben_info.cjsj;
          this.jichu_info.title = result.jiben_info.title;
          this.jichu_info.frxm = result.jiben_info.frxm;
          this.jichu_info.frnl = result.jiben_info.frnl;
          this.jichu_info.frzgbl = result.jiben_info.frzgbl;
          this.jichu_info.found_date = result.jiben_info.found_date;
          this.jichu_info.xydm = result.jiben_info.xydm;
          this.jichu_info.hyfl = result.jiben_info.hyfl;
          this.jichu_info.zczj = result.jiben_info.zczj;
          this.jichu_info.zclx = result.jiben_info.zclx;
          this.jichu_info.zcqy = result.jiben_info.zcqy;
          this.jichu_info.mbdz = result.jiben_info.mbdz;
          this.jichu_info.sbrs = result.jiben_info.sbrs;
          this.jichu_info.sbjf = result.jiben_info.sbjf;
          this.jichu_info.jy_score = result.jiben_info.jy_score;
          this.yshd_list_all = this.filterFilledYshd(
            result.jiben_info.yshd_list || [],
          );
          this.yshd_list =
            this.yshd_list_all.length > 3
              ? this.yshd_list_all.slice(0, 3)
              : this.yshd_list_all;
          this.gudong_list_all = result.jiben_info.gudong_list || [];
          if (this.gudong_list_all.length > 3) {
            this.gudong_list = this.gudong_list_all.slice(0, 3);
          } else {
            this.gudong_list = this.gudong_list_all;
          }

          // 纳税信息
          this.ns_info.xydj = result.nashui_info.xydj;
          this.ns_info.zzxse_12 = result.nashui_info.zzxse_12;
          this.ns_info.nsrzl = result.nashui_info.nsrzl;
          this.ns_info.zzxse_24 = result.nashui_info.zzxse_24;
          this.ns_info.qsjlcs_12 = result.nashui_info.qsjlcs_12;
          this.ns_info.nsze_12 = result.nashui_info.nsze_12;
          this.ns_info.dqqcje = result.nashui_info.dqqcje;
          this.ns_info.nsze_24 = result.nashui_info.nsze_24;
          this.ns_info.yznjje_3 = result.nashui_info.yznjje_3;
          this.ns_info.zsyne_12 = result.nashui_info.zsyne_12;
          this.ns_info.znjje_12 = result.nashui_info.znjje_12;
          this.ns_info.sbys_120 = result.nashui_info.sbys_120;
          this.ns_info.znjcs_12 = result.nashui_info.znjcs_12;
          this.ns_info.zclx0sbys_12 = result.nashui_info.zclx0sbys_12;
          this.ns_info.qnzcje = result.nashui_info.qnzcje;
          this.ns_info.qnlre = result.nashui_info.qnlre;
          this.ns_info.qnfzl = result.nashui_info.qnfzl;
          this.ns_info.qzjll = result.nashui_info.qzjll;

          this.znj_list_all = result.nashui_info.znj_list;
          console.log(this.znj_list_all);
          if (this.znj_list_all.length > 2) {
            this.znj_list = this.znj_list_all.slice(0, 2);
          } else if (
            this.znj_list_all[0].znsj == undefined ||
            this.znj_list_all[0].znsj == ""
          ) {
            this.znj_list = this.znj_list_all = [];
          } else {
            this.znj_list = this.znj_list_all;
          }
          console.log(this.znj_list);

          this.swcf_list = result.nashui_info.swcf_list;
          if (this.swcf_list == null) {
            this.swcf_list = [];
          } else if (this.swcf_list.length > 2) {
            this.swcf_list1 = this.swcf_list.slice(0, 2);
          } else if (
            this.swcf_list[0].djrq == "" ||
            this.swcf_list[0].djrq == undefined
          ) {
            this.swcf_list1 = this.swcf_list = [];
          } else {
            this.swcf_list1 = this.swcf_list;
          }

          this.wsb_list = result.nashui_info.wsb_list;

          //发票信息
          this.fp_info.kpjj_45 = result.fapiao_info.kpjj_45;
          this.fp_info.kpje_1 = result.fapiao_info.kpje_1;
          this.fp_info.kphb_3 = result.fapiao_info.kphb_3;
          this.fp_info.kpje_3 = result.fapiao_info.kpje_3;
          this.fp_info.kphb_6 = result.fapiao_info.kphb_6;
          this.fp_info.kpje_6 = result.fapiao_info.kpje_6;
          this.fp_info.kphb_12 = result.fapiao_info.kphb_12;
          this.fp_info.kpje_12 = result.fapiao_info.kpje_12;
          this.fp_info.xykh_3 = result.fapiao_info.xykh_3;
          this.fp_info.kpje_24 = result.fapiao_info.kpje_24;
          this.fp_info.xykh_12 = result.fapiao_info.xykh_12;
          this.fp_info.xykp_12 = result.fapiao_info.xykp_12;
          this.fp_info.xykhzb_12 = result.fapiao_info.xykhzb_12;
          this.fp_info.jkpzz_12 = result.fapiao_info.jkpzz_12;
          this.fp_info.hcfpzb_12 = result.fapiao_info.hcfpzb_12;
          this.fp_info.hcjezb_12 = result.fapiao_info.hcjezb_12;
          this.fp_info.zcdp_12 = result.fapiao_info.zcdp_12;
          this.fp_info.zcdpb2_12 = result.fapiao_info.zcdpb2_12;
          this.fp_info.zcwkp_12 = result.fapiao_info.zcwkp_12;
          this.receipt_list = result.fapiao_info.receipt_list;
          //供应商信息
          this.client_list = result.gongyingshang_info.client_list;
          this.supplier_list = result.gongyingshang_info.supplier_list;
        }
      });
    },
    copyBaogao(item) {
      console.log(this.jichu_info.mbdz);
      let url = ``;
      if (item == 0) {
        url = this.jichu_info.mbdz;
        this.$message({
          message: "已复制报告链接，可转发给其他用户查看报告",
          type: "success",
          customClass: "mymessagestyle",
        });
      } else if (item == 1) {
        url = this.jichu_info.title;
        this.$message({
          message: "已复制公司名称",
          type: "success",
          customClass: "mymessagestyle",
        });
      } else if (item == 2) {
        url = this.jichu_info.xydm;
        this.$message({
          message: "已复制税号",
          type: "success",
          customClass: "mymessagestyle",
        });
      } else if (item == 3) {
        url = this.jichu_info.frxm;
        this.$message({
          message: "已复制法人姓名",
          type: "success",
          customClass: "mymessagestyle",
        });
      }
      let oInput = document.createElement("input");
      oInput.value = url;

      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.remove();
    },
    // 切换税务处罚模态框开关
    changeModel2() {
      this.isModal2 = !this.isModal2;
    },
    // 查看税务处罚明细
    lookSwcf(item) {
      console.log(item);
      this.swcf_xiangxi = item;
      this.isModal2 = !this.isModal2;
    },
    // 打开模态框
    openModal() {
      this.$alert(
        "<div class='contentd'><p style='text-align:center;'>一</p><img src='https://static.szsmjr.com/znjShow/1.png'><p style='text-align:center;'>二</p><img src='https://static.szsmjr.com/znjShow/2.png'><p style='text-align:center;'>三</p><img src='https://static.szsmjr.com/znjShow/3.png'><p style='text-align:center;'>四</p><img src='https://static.szsmjr.com/znjShow/4.png'><p style='text-align:center;'>五</p><img src='https://static.szsmjr.com/znjShow/5.png'></div>",
        "HTML 片段",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          showClose: false,
          customClass: "persdsd",
          confirmButtonText: "关闭",
        },
      );
    },
  },
};
</script>

<style lang="scss">
.row {
  width: 100%;
  height: 23rem;
  position: relative;
  background-image: url(../assets/header.02571434.png);
  background-size: cover;
  background-position: 50%;
  max-height: 200px;
  -webkit-transition: background-image 0.3s ease;
  transition: background-image 0.3s ease;
}

.zfbg-btn {
  position: absolute;
  top: 26%;
  right: 0;
  height: 4rem;
  border: 1px solid #fff;
  border-radius: 20px 0 0 20px;
  width: 11rem;
  font-size: 1.5rem;
  font-weight: 700;
  background-color: #00113c;
  color: #fff;
}

.top_down {
  position: absolute;
  bottom: -4%;
  left: 5%;
  width: 90%;
  height: 80px;
  background-color: #fff;
  border-radius: 10px;
  text-align: center;
  padding-top: 1rem;
  box-sizing: border-box;
}

.top_down li {
  height: 4rem;
  font-size: 2.3rem;
  font-weight: bolder;
}

.middle_Basic_information {
  width: 100%;
  height: 100%;
  background-color: #fff;
  margin-top: 3rem;
}

.middle_Basic_information_top {
  font-size: 1.5rem;
  font-weight: 700;
  width: 100%;
  height: 4.5rem;
  line-height: 4.5rem;
  padding-left: 5px;
  margin-bottom: 1.5rem;
}

.middle_Basic_information_top_info {
  float: left;
  width: 25%;
  color: #626571;
  font-size: 1.75rem;
  text-align: center;
}

.selected {
  color: #000;
  border-bottom: 2px solid pink;
}

.middle_all {
  margin-left: 5px;
  margin-right: 10px;
  border: 1px solid #eff0f4;
}

.middle_all,
.middle_all_four {
  position: relative;
  padding: 10px;
}

.middle_Basic_information_middle {
  padding-left: 0;
}

.middle_Basic_information_middle li {
  height: 4.5rem;
  max-height: 6.5rem;
  width: 100%;
  font-size: 1.4rem;
  color: #626571;
}

.middle_Basic_information_middle_left {
  float: left;
  width: 35%;
  height: 100%;
}

.middle_Basic_information_middle_right {
  margin-right: 1rem;
  padding-right: 1rem;
  width: 55%;
  height: 100%;
  overflow: hidden;
  word-wrap: break-word;
  float: right;
}

.middle_Basic_information_middle_right p {
  margin-top: 0;
}

.address-row {
  height: auto !important;
  min-height: 4.5rem;
  max-height: none !important;
}

.address-row:after {
  content: "";
  display: block;
  clear: both;
}

.address-row .middle_Basic_information_middle_left,
.address-row .middle_Basic_information_middle_right {
  height: auto;
}

.address-row .middle_Basic_information_middle_right {
  overflow: visible;
}

.new_li {
  height: 4.5rem;
  max-height: 6.5rem;
  width: 100%;
  font-size: 1.3rem;
  color: #626571;
  margin-bottom: 0;
}

.tbdiv {
  width: 100%;
  font-size: 1.25rem;
  color: #626571;
  position: relative;
  margin-top: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  background-color: #fff;
}

.middle_Basic_information_tb {
  border-bottom: 1px dashed grey;
  border-collapse: collapse;
  text-align: center;
  margin-top: 0;
}

.middle_Basic_information_tb th {
  height: 2rem;
  background-color: #f6f9ff;
}

.middle_Basic_information_tb th,
td {
  padding: 10px;
  text-align: center;
  border: none;
}

.odd {
  background-color: #f6f9ff;
}

.middle_Basic_information_tb td {
  height: 3rem;
}

.bottom_img {
  margin-top: 10px;
}

.bottom_img img {
  width: 100%;
  height: 100%;
}

.mymessagestyle {
  min-width: 300px !important;
  font-size: 12px !important;

  .el-message__content {
    font-size: 10px !important;
  }
}

.tip {
  border: 1px solid #007bff;
  -webkit-box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);
  border-radius: 10px;
  padding: 10px;
  margin-top: 5px;
  margin-bottom: 10px;
  width: 90%;
  font-size: 1.4rem;

  .view-detail-button {
    padding: 4px 16px;
    background-color: #409eff;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    -webkit-transition: background-color 0.2s ease;
    transition: background-color 0.2s ease;
  }
}

.middle_Basic_information_middle_second {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;

  p {
    margin-top: 5px;
    margin-bottom: 8px;
  }

  li {
    width: 50%;
    margin-bottom: 10px;

    p {
      font-size: 1.4rem;
      color: #a9a2a8;
    }

    span {
      color: #000;
      font-size: 1.5rem;
    }
  }
}

.middle_all_divtb3 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;

  .middle_all_3_tb {
    border-collapse: collapse;
    font-size: 1.5rem;
    width: 100%;
    background-color: #fff;

    td {
      border: none;
      text-align: center;
      height: 25px;
    }

    th {
      color: #413e41;
      font-weight: lighter;
      border: none;
      text-align: center;
      height: 1rem;
    }
  }
}

.middle_Basic_information_middle_second p {
  margin-top: 5px;
  margin-bottom: 8px;
}

.middle_all_four {
  .fonsi {
    background-color: #2187fe;
    float: left;
    color: #fff;
    width: 25px;
    border-radius: 5px;
    text-align: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .middle_all_4_span {
    margin-top: 1rem;
    font-size: 2rem;
    margin-left: 0.5rem;
    color: #212020;
    font-weight: 700;
  }

  .separator {
    width: 100%;
    border-top: 1px dashed #ccc;
    margin-top: 10px;
  }

  .middle_all_divtb4 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;

    .middle_all_4_tb {
      border-collapse: collapse;
      font-size: 1.3rem;
      width: 100%;

      th {
        color: #413e41;
        font-weight: lighter;
        font-size: 1.4rem;
      }

      td {
        border: none;
        text-align: center;
        height: 3.5rem;
      }
    }
  }
}

.persdsd {
  position: fixed;
  top: 2.5%;
  left: 0;
  width: 95% !important;
  height: 95%;
  background-color: rgba(0, 0, 0, 0.5);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  z-index: 1000;
  overflow-x: auto !important;
  overflow-y: auto !important;
  padding: 30px 10px 0px 10px;

  .el-message-box__message {
    .contentd {
      height: 80%;
      width: 100%;
      overflow-x: auto;
      overflow-y: auto;
      background: #fff;
    }

    img {
      width: 750px;
      height: 450px;
    }
  }

  .el-message-box__btns {
    position: fixed;
    bottom: 20px;
    text-align: left;
  }

  .el-message-box__header {
    display: none;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  z-index: 1000;

  .modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    width: 400px;
    max-width: 90%;
    text-align: left;

    p {
      margin: 10px 0;
    }

    h3 {
      margin-top: 0;
    }

    button {
      margin-top: 20px;
      padding: 10px 20px;
      background-color: #007bff;
      color: #fff;
      border: none;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}

.score-modal-overlay {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.score-modal-content {
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.score-modal-body {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.score-notice {
  margin: 0 0 14px !important;
  font-size: 1rem;
  line-height: 1.75;
  color: #111827;
  font-weight: 600;
}

.score-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 14px;
}

.score-item {
  margin: 0;
  padding: 12px;
  background: #f8fbff;
  border: 1px solid #e3ecf5;
  border-radius: 10px;
  font-size: 0.94rem;
  line-height: 1.7;
  color: #4b5563;
}

.score-label {
  font-weight: 700;
  color: #0f766e;
}

.score-modal-content > button {
  margin-top: 16px !important;
  align-self: flex-start;
}

.yishang {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 90%;
  margin: 10px 0;
  color: grey;

  span {
    margin: 0 10px;
    white-space: nowrap;
  }
}

.yishang:before {
  content: "";
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  border-bottom: 1px dashed grey;
}

.yishang:after {
  content: "";
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  border-bottom: 1px dashed grey;
}

.tiptip {
  border: 1px solid #007bff;
  -webkit-box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);
  border-radius: 8px;
  padding: 8px 10px;
  margin: 10px 5px;
  font-size: 1.4rem;
  color: #666;
  line-height: 1.5;
}

.credit-score-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 12px 10px;
  border-radius: 12px;
  max-width: 100%;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
}

.progress-container {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  min-width: 0;
  width: 100%;
  position: relative;
}

.progress-bar {
  position: relative;
  height: 14px;
  background: #e5e7eb;
  border-radius: 7px;
  overflow: hidden;
  width: 100%;
}

.progress-gradient {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#4eaaff),
    color-stop(#60cfff),
    to(#22c55e)
  );
  background: linear-gradient(90deg, #4eaaff, #60cfff, #22c55e);
}

.score-pointer {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  z-index: 10;
  background: #000;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.score-pointer:after {
  content: "";
  position: absolute;
  top: -6px;
  left: 50%;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #000;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.scale-texts {
  position: relative;
  margin-top: 6px;
  font-size: 11px;
  color: #6b7280;
  width: 100%;
  height: 12px;
}

.scale-texts span {
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.labels {
  position: relative;
  margin-top: 6px;
  font-size: 11px;
  font-weight: 500;
  color: #374151;
  width: 100%;
  height: 16px;
}

.labels span {
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.view-detail-button {
  padding: 4px 16px;
  background-color: #409eff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}
</style>
